module.exports = __webpack_public_path__ + "img/emoji_58.4def97cf.png";